import { render } from "./ReviewManagement.vue?vue&type=template&id=ef3764b4&scoped=true"
import script from "./ReviewManagement.vue?vue&type=script&lang=js"
export * from "./ReviewManagement.vue?vue&type=script&lang=js"

import "./ReviewManagement.vue?vue&type=style&index=0&id=ef3764b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3764b4"]])

export default __exports__